<template>
  <div class="d-none d-lg-block col-lg-2">


    <div class="bg-dark-nav mt-3 mx-1 px-2 shadow-lg" id="menu-right">


      <nav class="main-nav d-none d-lg-block">
        <menu-user-widget/>


        <ul class="mt-4">
          <item v-for="(item,index) in items"
                :key="index"
                :icon="item.icon"
                :id="item.id"
                :item-class="`${item.name}-${$store.getters['User/isAdmin'] ? 'admin' : 'user'}`"
                :access="item.access"
                :action="item.action"
                :name="item.name"
                :route="item.route"
                :children="item.children"></item>
          <m-a target="_blank" href="https://mixitweb.com/release-note">
            <li class="version-item">
              <span class="mx-1">ورژن:</span>
              {{ appVersion }}
            </li>
          </m-a>
        </ul>

      </nav>
    </div>
  </div>
</template>

<script>
import Item from './item.vue'
import WidgetWallet from "../Wallet/WidgetWallet";
import MenuUserWidget from "@/plugin/components/dashboard/DashboardMenu/MenuUserWidget.vue";
import pkg from '../../../../../package.json'   // مسیر را نسبت به فایل درست کن

export default {
  name: "desktop",
  components: {MenuUserWidget, Item, WidgetWallet},
  props: ['items'],
  data() {
    return {
      appVersion: pkg.devDependencies["@moeinmdn/mixitweb-front-modules"]
    }
  },
}
</script>

<style scoped>
#menu-right {
  height: 100%;
}

.bg-dark-nav {

  background: #1c1c1c;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.bg-dark-nav * {
  color: #fff;
}

ul li {
  list-style: none;
}

ul li a:focus {

  color: #7f9afd;

}

ul li a {
  color: #ffffff;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 15px;
  outline: none;
}


.main-nav {
  padding: 7px 0;
  list-style: none;
}

.version-item {
  padding-right: 1rem;
  text-align: right;
  text-decoration: none;
  cursor: pointer;
}

</style>